@use "../../styles/breakpoint.module.scss" as *;

div.root {
    margin-inline: 0;
    padding-inline: var(--labui-container-margin);
    position: relative;

    // Whatever container size is chosen in the cms, should be full
    // width on mobile
    @media ($below-mobile) {
        div:has(> section) {
            grid-column: 1 / -1;
        }
    }

    > div {
        position: relative;
        z-index: 1;
    }

    --extra-padding-top: 0px;
    --extra-padding-bottom: 0px;
}

.gradient {
    composes: root;
    composes: dark from "../../styles/theming.module.css";
    display: flex;
    background: var(--xcient-gradient);
    padding-block: calc(var(--spacer-104) + var(--extra-padding-top, 0px))
        calc(var(--spacer-104) + var(--extra-padding-bottom, 0px));
    flex-direction: column;
    justify-content: center;
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.overlay {
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            var(--rotate),
            rgb(var(--black-base) / 0%) 0%,
            rgb(var(--black-base) / 0%) 68.75%,
            rgb(var(--black-base) / 100%) 100%
        );
        z-index: 0;
    }
}

.overlayOff {
    visibility: visible;
}

.overlayBottom {
    --rotate: 180deg;

    composes: overlay;
}

.overlayTop {
    --rotate: 0deg;

    composes: overlay;
}

.overlayTopBottom {
    --rotate: 0deg;

    composes: overlay;

    &::after {
        background: linear-gradient(
            var(--rotate),
            rgb(var(--black-base) / 100%) 0%,
            rgb(var(--black-base) / 0%) 31.25%,
            rgb(var(--black-base) / 0%) 68.75%,
            rgb(var(--black-base) / 100%) 100%
        );
    }
}

.overlayCover {
    composes: overlay;

    &::after {
        background: rgb(var(--black-base) / 55%);
    }
}
